import * as PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { Link } from 'react-router-dom';
import { BarsOutlined } from '@ant-design/icons';

import config from 'config/index';

import DeleteInfo from '../../containers/Info/DeleteInfo';

import rule from './Info.rule';

const infoPropTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    categoryId: PropTypes.string.isRequired,
};

export const infoShape = PropTypes.shape(infoPropTypes);

const Info = ({ title, id, categoryId }) => {
    const { css } = useFela();
    return (
        <div className={css(rule)}>
            <h4>
                <BarsOutlined />
                <Link to={config.routes.infoDetail.replace(':categoryId', categoryId).replace(':id', id)}>{title}</Link>
                <DeleteInfo className="delete-info" id={id} categoryId={categoryId} size="small" />
            </h4>
        </div>
    );
};

Info.propTypes = infoPropTypes;

export default Info;
